module.exports = "/_next/static/images/75cd68254bbd4014a95c2634b2bc8c63-roxinho-basicos-flutuantes-md@1x.png.webp";